import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTwitterStyle0 = gravityIconIndividualCss;

const GravityIconTwitter = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '02ab3f14725a5f32ec07d55f95280c67afaa8635', color: this.color, size: this.size }, h("svg", { key: 'b525f2722e3aa9aa1702f14aa1bc01b8d452cd38', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'f394a8a93fefc307bd44edda50d908b3346845bb', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.892 17.784a9.705 9.705 0 0 0 9.78-9.771v-.447a6.914 6.914 0 0 0 1.703-1.777 6.952 6.952 0 0 1-1.973.54 3.433 3.433 0 0 0 1.508-1.862c-.673.4-1.41.68-2.178.828a3.443 3.443 0 0 0-5.946 2.355c0 .263.027.525.084.781a9.734 9.734 0 0 1-7.082-3.629 3.508 3.508 0 0 0-.465 1.731A3.415 3.415 0 0 0 4.858 9.39a3.415 3.415 0 0 1-1.563-.428v.046a3.443 3.443 0 0 0 2.792 3.369 3.57 3.57 0 0 1-1.6.056 3.434 3.434 0 0 0 3.21 2.391 6.923 6.923 0 0 1-5.072 1.424 9.762 9.762 0 0 0 5.267 1.535Z", fill: "currentColor" }))));
    }
};
GravityIconTwitter.style = GravityIconTwitterStyle0;

export { GravityIconTwitter as gravity_icon_twitter };

//# sourceMappingURL=gravity-icon-twitter.entry.js.map